import { UntypedFormControl } from '@angular/forms';

export function BirthdayValidator(control: UntypedFormControl) {
    let minDate = getMinimumDate();
    let maxDate = new Date();
    let tooOldYear = maxDate.getFullYear() - 150;
    let tooOldDate = new Date();
    tooOldDate.setFullYear(tooOldYear)
    let tooOldBool = true;
    var isValid = true;
    var undefinedBool = true;

    if(control.value == undefined || control.value == '')
    {
        undefinedBool = false;
        return undefinedBool ? null : { 'undefined': true };
    }

    if(control.value > maxDate && control.value != '')
    {
        isValid = false;
    }

    if(control.value > minDate)
    {
        isValid = false;
    }
    else if(control.value < tooOldDate)
    {
        tooOldBool = false;
        return tooOldBool ? null : { 'tooOld': true };
    }


    return isValid ? null : { 'birthday': true };
}

function getMinimumDate(){
    let currentDate = new Date();
    let goodDate = currentDate.getFullYear() - 16;
    currentDate.setFullYear(goodDate);
    return currentDate;
  }